import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useShippingBoIntegrationConnectionRedirect(
  shop: ShopDto,
) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shop.id);
  const mutation = $api.useMutation("post", "/shops/{shopId}/integrations/shippingbo/auth");

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async () => {
      const result = await mutation.mutateAsync({ params: { path: { shopId: shop.id } } });
      window.location.href = decodeURIComponent(result as string);
    },
  });
}
